const ITEMS = [
  "Plots",
  "Builder Floors",
  "Farmhouses",
  "Commercial Spaces",
  "Agricultural Land",
  "Sector 33 · Hisar",
  "Sale · Purchase · Rent",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative py-5 lg:py-6 bg-[#131311] overflow-hidden select-none"
      data-testid="marquee-strip"
    >
      <div className="lj-marquee-track">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="mx-8 font-serif italic text-2xl lg:text-3xl text-[#faf3e0]">
              {t}
            </span>
            <span className="text-[#c5a059] text-lg">✦</span>
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#131311] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#131311] to-transparent" />
    </div>
  );
};
